const ActionTypes = {
  ISLOGIN: 'ISLOGIN',
  IS_LOADING: 'IS_LOADING',
  CHANGE_USER: 'CHANGE_USER',
  CHANGE_USER_GOOGLE_LOGIN: 'CHANGE_USER_GOOGLE_LOGIN',
};

export const ActionProduct = {
  IS_LOADING: 'IS_LOADING',
  SUCCESS_CREATE: 'SUCCESS_CREATE',
  SUCCESS_UPDATE: 'SUCCESS_UPDATE',
  DATA_PRODUCT: 'DATA_PRODUCT',
  SEARCH: 'SEARCH',
};

export default ActionTypes